import {$, PageCollection} from 'simpli-web-sdk'
import Motorista from '@/model/resource/Motorista'
import CockpitRequest from '@/model/request/CockpitRequest'

export default class MotoristaCollection extends PageCollection<Motorista> {
  constructor(
    filter = {},
    endPoint: string | null = null,
    perPage: number | null = 10,
    currentPage: number | null = 0,
  ) {
    super(Motorista, filter, perPage, currentPage)
    this.endpoint = endPoint
  }

  async getPerformance(request: CockpitRequest, spinner = 'getPerformance') {
    const fetch = async () => await this.POST(`/user/motorista/performance`, request)
    return await $.await.run(fetch, spinner)
  }
}
